/* globals google */

'use strict';

var base = require('base/storeLocator/storeLocator');
var utils = require('../utils');
var updateStoreLink = require('../header/store').updateStoreLink;

/**
 * gets the preferred store ID from the header
 * @returns {string} html from template
 */
function getPreferredStoreId() {
    return $('.sub-nav-store-info').data('preferred-store-id');
}

function encodeQueryParams(params) {
    return Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
}

/**
 * gets store link template to replace in the ajax
 * @param {boolean} isMyStore - is this store the preferred store link
 * @param {string} storeID - the store ID
 * @returns {string} html from template
 */
function getMyStoreLinkTemplate(isMyStore, storeID) {
    var tmpl = $('#my-store-link-template').clone();
    var $storeLink = $('.my-store-link', tmpl);
    var $storeLabel = $('.my-store-label', tmpl);
    var storeDetailsUrl = $storeLink.data('select-store') + '?storeId=' + storeID;

    $storeLink.attr('data-select-store', storeDetailsUrl);
    $storeLink.attr('data-store-id', storeID);

    if (isMyStore) {
        $storeLabel.removeClass('d-none').addClass('d-inline-block');
        $storeLink.addClass('d-none').removeClass('d-inline-block');
    } else {
        $storeLink.removeClass('d-none').addClass('d-inline-block');
        $storeLabel.addClass('d-none').removeClass('d-inline-block');
    }

    return tmpl.html();
}

/**
 * Uses google maps api to render a map
 * @param {Array} filters - An array of filters to limit the map icons
 */
function maps(filters) {
    var map;
    var infowindow = new google.maps.InfoWindow();
    var storeFilters = filters || [];
    var preferredStoreId = getPreferredStoreId();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(37.09024, -95.712891);
    var mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    var icons = {
        gamestop: {
            path: 'M13.2 16.75a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 1 1 0 6.4M13.2 2C7.014 2 2 7.014 2 13.2 2 19.386 13.2 34 13.2 34s11.2-14.614 11.2-20.8S19.386 2 13.2 2',
            fillColor: 'white',
            fillOpacity: 1,
            scale: 1.1,
            strokeColor: '#da362c',
            strokeWeight: 3,
            anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(12, 12)
        },
        // 2x the size but the number isn't centered
        // M26.4 4.0C19.916 4.0 14.028 9.888 14.028 16.4 14.028 22.912 26.4 48.0 26.4 48.0s12.372-25.088 12.372-31.6C38.772 9.888 32.884 4.0 26.4 4.0
        gamestop2x: {
            path: 'M26.4 4.0C19.916 4.0 14.028 9.888 14.028 16.4 14.028 22.912 26.4 48.0 26.4 48.0s12.372-25.088 12.372-31.6C38.772 9.888 32.884 4.0 26.4 4.0',
            fillColor: 'white',
            fillOpacity: 1,
            scale: 1.1,
            strokeColor: '#da362c',
            strokeWeight: 3,
            // anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(24, 18)
        },
        thinkgeek: {
            path: 'M13.2 16.75a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 1 1 0 6.4M13.2 2C7.014 2 2 7.014 2 13.2 2 19.386 13.2 34 13.2 34s11.2-14.614 11.2-20.8S19.386 2 13.2 2',
            fillColor: 'white',
            fillOpacity: 1,
            scale: 1.1,
            strokeColor: '#8ac953',
            strokeWeight: 3,
            anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(12, 12)
        },
        cricket: {
            path: 'M13.2 16.75a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 1 1 0 6.4M13.2 2C7.014 2 2 7.014 2 13.2 2 19.386 13.2 34 13.2 34s11.2-14.614 11.2-20.8S19.386 2 13.2 2',
            fillColor: 'white',
            fillOpacity: 1,
            scale: 1.1,
            strokeColor: 'black',
            strokeWeight: 3,
            anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(12, 12)
        },
        home: {
            path: 'M13.2 16.75a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 1 1 0 6.4M13.2 2C7.014 2 2 7.014 2 13.2 2 19.386 13.2 34 13.2 34s11.2-14.614 11.2-20.8S19.386 2 13.2 2',
            fillColor: 'white',
            fillOpacity: 1,
            scale: 1.1,
            strokeColor: 'black',
            strokeWeight: 3,
            anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(12, 12)
        }
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var numberedLabel = !isNaN(item.storeInventoryCount);
        var undoSafetyStockRemoval = 1;
        var inventoryCount = item.storeInventoryCount + undoSafetyStockRemoval;
        var labelObj = numberedLabel ? { text: inventoryCount.toString(), color: 'black', fontSize: '16px', fontWeight: 'bold'} : null;
        var markerIcon = numberedLabel ? icons.gamestop2x :icons.gamestop;
        var thisStoreId = item.storeId;
        var isMyStore = preferredStoreId && thisStoreId && thisStoreId.toString() === preferredStoreId.toString();

        if (!storeFilters.length) {
            Object.keys(icons).forEach(function (icon) {
                if (isMyStore) {
                    markerIcon = icons.home;
                }
            });

            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: markerIcon,
                label: labelObj
            });

            var storesResultsHtml = $(item.infoWindowHtml).clone();
            if (preferredStoreId && thisStoreId) {
                var html = getMyStoreLinkTemplate(isMyStore, thisStoreId);
                var $storeBlock = $('.my-preferred-store-block', storesResultsHtml);
                $storeBlock.empty().append(html);
            }

            marker.addListener('click', function () {
                var storeID = storesResultsHtml.find('[data-store-id]').data('storeId');
                var $storeOpenText = storesResultsHtml.find('[data-store-open-text]');
                var isStoreOpen = $('[data-store-hours][data-store-id="' + storeID + '"]').data('storeOpen');
                var storeHoursText = $('[data-store-hours][data-store-id="' + storeID + '"]').data('store-hours-text');

                if (isStoreOpen) {
                    storesResultsHtml.attr('data-store-open', true);
                } else {
                    storesResultsHtml.attr('data-store-open', false);
                }
                if (storeHoursText) {
                    $storeOpenText.text(storeHoursText);
                }
                infowindow.setOptions({
                    content: storesResultsHtml[0].outerHTML
                });
                var myPreferredStore = storesResultsHtml.find('#my-preferred-store').data('url');
                if (myPreferredStore) {
                    $.ajax({
                        url: myPreferredStore,
                        type: 'get',
                        success: function (data) {
                            $('.my-preferred-store-block-map').html(data);
                        }
                    });
                }
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        }
    });

    // Don't zoom in too far on only one marker
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
    }

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

/**
 * On search success, set searched values as data on form elements to maintain state
 * Init search button to disabled until fields have changed
 */
function resetStoreLocatorFields() {
    const radius = $('#radius').val();
    $('#radius').data('radius', radius);
    const postalCode = $('#store-postal-code').val();
    $('#store-postal-code').data('postalcode', postalCode);
    $('.store-locator-drawer-fields .btn-storelocator-search').attr('disabled', true);
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;
    var isFindStorePage = $('.page').data('action') === 'Stores-Find';

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    resetStoreLocatorFields();

    if (data.storesResultsHtml) {
        var storesResultsHtml = $(data.storesResultsHtml);
        var preferredStoreId = getPreferredStoreId();
        if (preferredStoreId) {
            storesResultsHtml.find('.my-preferred-store-block').each(function () {
                var thisStoreId = $(this).data('store-id');
                if (thisStoreId) {
                    var isMyStore = thisStoreId.toString() === preferredStoreId.toString();
                    var html = getMyStoreLinkTemplate(isMyStore, thisStoreId);
                    $(this).empty().append(html);
                }
            });
        }
        $resultsDiv.append(storesResultsHtml);
        exportBase.checkStoreHours(); // eslint-disable-line no-use-before-define
        exportBase.buildStoreHours(); // eslint-disable-line no-use-before-define

        // Hide 0 stores message on PDP store modal
        if (!hasResults && $('.store-locator-no-results-search').length) {
            $('.store-locator-results-header').hide();
        }
    }

    // Show or hide no results in Find Store only
    if (isFindStorePage) {
        // service locations: "[]" // string
        if (data.locations.length > 2) {
            $('.store-locator-no-results').hide();
        } else {
            $('.store-locator-no-results').show();
        }
    // Show or hide no results in modal only
    } else if (hasResults) {
        $('.store-locator-no-results').hide();

        if ($('.store-locator-no-results-search').length) {
            $('.store-locator-no-results-search').hide();
            $('.store-locator-results-header').show();
        }
    } else if ($('.store-locator-no-results-search').length) {
        $('.store-locator-no-results-search').show();
        $('.store-locator-no-results').hide();
        $('.store-locator-results-header').hide();
    } else {
        $('.store-locator-no-results').show();
    }
}

/**
 * @param {string} address - address coming from the search input (city, state, zip)
 * @param {string} submitURL - URL to submit the search to. Comes from a data attribute
 * tied to the submit button.
 */
function getResultsfromGeocode(address, submitURL) {
    var $radius = $('#radius').val();
    var url = submitURL;
    var csrf = $('input.csrf-protection');
    var urlParams = {
        radius: $radius,
        postalCode: address
    };
    $.post(utils.appendToUrl(url, urlParams), {
        postalCode: address,
        csrf_token: csrf.val(),
        radius: $radius
    }).done(function (data) {
        $(document).trigger('storelocator:search-completed', data);
        $('#store-search-input').val('');
        updateStoresResults(data); //eslint-disable-line
    });
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @param {Object} dataCTR - CTR response
 * @returns {boolean} false to prevent default event
 */
function search(element, dataCTR) {
    var flag = true;
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('#radius').val();
    var url = $form.attr('action');
    var $isinvisibleRecaptcha = $('.invisible-recaptcha');
    if ($isinvisibleRecaptcha.length) {
        if (!(dataCTR && dataCTR.ctr)) {
            window.grecaptcha.execute();
            flag = false;
        }
    }
    if (flag) {
        var payload = $form.is('form') ? $form.serialize() : {
            postalCode: $form.find('[name="postalCode"]').val(),
            radius: radius
        };

        $.ajax({
            url: url,
            type: $form.attr('method'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                spinner.stop();
                if ($isinvisibleRecaptcha.length) {
                    window.grecaptcha.reset();
                }
                if (!data.reCaptchaNotValidated || $isinvisibleRecaptcha.length === 0) {
                    $(document).trigger('storelocator:search-completed', data);
                    updateStoresResults(data);
                    $('.profile-find-a-store #store-search-input').val('');
                }
            }
        });
    }
    return false;
}

/**
 * Checks if Single Page Checkout
 * @returns {boolean} true if Single Page Checkout
 */
function isSinglePageCheckout() {
    return $('.single-page-checkout') && $('.single-page-checkout').length > 0;
}

/**
 * Formats store hours (21:00) to customer friendly time (9:00 PM)
 * @param {string} time - the time to format (21:00)
 * @returns {string} customer friendly time (9:00 PM)
 */
function formatTime(time) {
    // Check correct time format and split into components
    var formattedTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (formattedTime.length > 1) { // If time format correct
        formattedTime = formattedTime.slice(1); // Remove full string match value
        if (isSinglePageCheckout()) {
            formattedTime[5] = +formattedTime[0] < 12 ? 'am' : 'pm'; // Set AM/PM
        } else {
            formattedTime[5] = +formattedTime[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        }
        formattedTime[0] = +formattedTime[0] % 12 || 12; // Adjust hours
    }

    return formattedTime.join('');
}

/**
 * Controls the disabled state of submit button on store locator drawer
 * If field values are different from initial values, enable search button
 */
function handleStoreLocatorFormChanges() {
    $('.store-locator-drawer-fields').on('keyup change paste', 'input, select, textarea', function () {
        const $radius = $('.store-locator-drawer-fields #radius');
        const radiusChanged = $radius.data('radius') !== $radius.val();

        const $postal = $('.store-locator-drawer-fields #store-postal-code');
        const postalChanged = $postal.data('postalcode') !== $postal.val();

        if (radiusChanged || postalChanged) {
            $('.store-locator-drawer-fields .btn-storelocator-search').attr('disabled', false);
        } else {
            $('.store-locator-drawer-fields .btn-storelocator-search').attr('disabled', true);
        }
    });
}

$(document).off('hide.bs.modal', '#inStoreInventoryModal').on('hide.bs.modal', '#inStoreInventoryModal', function () {
    // To trigger an analytics event on click of close button or on clicking outside the modal
    if ($('#isWebInStore').val() === 'false') {
        if (event && event.type === 'click') {
            $(this).trigger('pdp:inStoreInventoryModalClose');
        }
    }
});


var exportBase = $.extend({}, base, {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.jumbotron').hide();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }

        const siteSection = window.pageContext.siteSection;
        if (siteSection === 'shopflow') {
            localStorage.setItem('gme-pref-fulfillment', 'store');
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            /**
             * get stores from geolcation
             * @param {Object} urlParams - the url params of lat/long to retrieve
             */
            function getGeoStores(urlParams) {
                var url = $('[data-submit-url]').data('submitUrl');
                const storeLocatorRadius = $('.store-locator-radius-container .radius') ? $('.store-locator-radius-container .radius').find(":selected")?.val() : $('.store-search-radius-container .radius')?.find(":selected")?.val() ;
                var radius = storeLocatorRadius ? storeLocatorRadius : $('.results').data('radius');
                var params = urlParams;
                params.radius = radius;

                url = utils.appendToUrl(url, params);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                    }
                });
            }

            /**
             * success callback from navigator.geolocation.getCurrentPosition
             * @param {Object} position - lat/long coordinates
             */
            function successCallback(position) {
                var urlParams = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                getGeoStores(urlParams);
            }

            /**
             * sets default lat/long if position could not be found or was denied
             */
            function errorCallback() {
                var longitude = $('[data-submit-url]').data('default-long') || '-97.037080';
                var latitude = $('[data-submit-url]').data('default-lat') || '32.967970';
                var urlParams = {
                    lat: latitude,
                    long: longitude
                };
                getGeoStores(urlParams);
            }

            navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e, dataCTR) {
            e.preventDefault();
            search($(this), dataCTR);
        });

        handleStoreLocatorFormChanges();
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function (e, dataCTR) {
            $('<div class="radiusSelected d-none"></div>').insertBefore($(this));
            var $isinvisibleRecaptcha = $('.invisible-recaptcha');
            if ($isinvisibleRecaptcha.length) {
                if (!(dataCTR && dataCTR.ctr)) {
                    window.grecaptcha.execute();
                    return false;
                }
                if (payload && typeof payload === 'object') {
                    payload['g-recaptcha-response'] = dataCTR.ctr;
                }
            }
            return true;
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            var $elem = $(this);
            var storeInfo = null;
            var storeID = null;
            var conditionDetails = $(this).data('condition-details') || null;
            var selectedStore = $(this).closest('.store-result');
            let changeStoreURL = null;

            $elem.prop('checked', true);

            if (selectedStore.length) {
                storeID = selectedStore.data('store-id') || null;
                changeStoreURL = e.target.getAttribute('data-change-url') || '';
            }

            var searchPostalCode = $('.results').data('search-key').postalCode || null;
            if (!searchPostalCode) {
                var $form = $('.store-locator');
                if ($form.length) {
                    searchPostalCode = $form.find('[name="postalCode"]').val() || '';
                }
            }

            var data = {
                storeID: storeID,
                storeInfo: storeInfo,
                conditionDetails: conditionDetails,
                searchRadius: $('#radius').val(),
                searchPostalCode: searchPostalCode,
                event: e,
                changeStoreURL: changeStoreURL
            };

            $('body').trigger('store:removeCachedHtml');
            $('body').trigger('store:selected', data);

            // Set Fullfilment Selector in PDP
            $('.js-fulfilment-option').removeClass('selected');
            $('.js-fulfilment-option-store').addClass('selected').removeClass('js-outofstock');
            $('.js-fulfillment-selected').text('Pick Up in-store');
            $('.js-pdp-fulfillment-store-status').text('Available');
            $('.js-selectedFulfilmentOption').val('store');
            $('.js-pdp-fullfilment-info').hide();
            $('.js-pdp-fullfilment-info-store').show();
        }));
    },

    callStore: function () {
        $('.store-locator-container').on('click', '.call-store', (function (e) {
            e.preventDefault();
            var storeInfo = null;
            var storeID = null;
            var selectedStore = $(this).closest('.store-result');
            if (selectedStore.length) {
                storeInfo = selectedStore.data('store-info');
                storeID = storeInfo.ID || null;
            }

            var data = {
                storeID: storeID,
                storeInfo: storeInfo,
                event: e
            };

            $('body').trigger('store:callStore', data);
        }));
    },

    selectPreferredStore: function () {
        $('.store-locator-detail, .store-locator-container, .store-header-home-store').on('click', '[data-select-store]', function () {
            var $this = $(this);
            var selectStoreURL = $this.data('selectStore');
            var storeId = $this.data('storeId');

            if (storeId && selectStoreURL) {
                // update preferred store ID in the header
                $('.sub-nav-store-info').data('preferred-store-id', storeId);

                $.post(selectStoreURL, {
                    storeId: storeId
                }).done(function (data) {
                    if (data.error) {
                        return data.result.message;
                    }
                    window.location.reload();

                    return false;
                });
            }
        });
    },

    geoCodeSearch: function () {
        $('.btn-storelocator-search').on('click submit', function () {
            var $this = $(this);
            var $submitURL = $this.data('submitUrl');
            var $address = $('#store-search-input');
            var $addressValue = $address.val();

            if ($addressValue.length) {
                $address.removeClass('is-invalid');

                getResultsfromGeocode($addressValue, $submitURL);
            } else {
                $address.addClass('is-invalid');
            }

            return false;
        });
    },

    filterStores: function () {
        $('[data-filter-stores-link]').on('click', function () {
            $('[data-filter-stores-container]').toggleClass('open');
        });

        $('[data-filter-store]').on('change', function () {
            var $filterCheckboxes = $('[data-filter-store]');
            var filters = [];

            $filterCheckboxes.each(function (index, checkbox) {
                var $checkbox = $(checkbox);
                if ($checkbox.prop('checked')) {
                    filters.push($checkbox.val());
                }
            });

            maps(filters);

            $storeResults.removeClass('d-none');

            $storeResults.each(function (index, result) {
                var $result = $(result);
            });
        });
    },

    checkStoreHours: function () {
        var $stores = $('[data-store-id]');
        var date = new Date();
        var day = date.getDay();
        var rightNow = ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
        var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var openText = $('[data-open-text]').data('openText') || 'Open';
        var closedText = $('[data-closed-text]').data('closedText') || 'Closed';
        var isSPC = isSinglePageCheckout();
        var untilText = $('[data-closed-text]').data('untilText') || (isSPC ? 'until' : 'Until');
        var todayText = isSPC ? 'today' : 'Today';


        $stores.each(function (index, store) {
            var $store = $(store);
            var storeID = $store.attr('data-store-id');
            var hours = $store.attr('data-store-hours');
            var parsedHours = null;
            try {
                parsedHours = JSON.parse(hours);
            } catch (ex) {
                parsedHours = null;
            }

            if (parsedHours) {
                hours = JSON.parse(hours);

                var todaysHours = parsedHours.filter(function (storeHours) {
                    return storeHours.day === days[day];
                });

                if (todaysHours.length) {
                    var open = todaysHours[0].open || null;
                    var close = todaysHours[0].close || null;
                    if (open && close) {
                        var openHours = open.substring(0, 2);
                        var openMins = open.substring(2, 4);
                        var openTime = openHours + ':' + openMins;

                        var closeHours = close.substring(0, 2);
                        var closeMins = close.substring(2, 4);
                        var closeTime = closeHours + ':' + closeMins;

                        var $updateStore = $('[data-store-id="' + storeID + '"]');
                        var $storeOpenText = $updateStore.find('[data-store-open-text]');

                        var isStoreOpen = openTime <= rightNow && rightNow < closeTime;
                        var storeHoursText = null;
                        if (isStoreOpen) {
                            $updateStore.attr('data-store-open', true);
                            storeHoursText = openText + ' ' + untilText + ' ' + formatTime(closeTime);
                            if (isSPC) {
                                storeHoursText = openText + ' ' + untilText + ' <span>' + formatTime(closeTime) + '</span> ' + todayText;
                            }
                        } else {
                            $updateStore.attr('data-store-open', false);
                            if (open === 'CLOSED') {
                                storeHoursText = closedText + ' ' + todayText;
                            } else {
                                storeHoursText = closedText + ' ' + untilText + ' ' + formatTime(openTime);
                                if (isSPC) {
                                    storeHoursText = closedText + ' ' + untilText + ' <span>' + formatTime(openTime) + '</span>';
                                }
                            }
                        }

                        if (storeHoursText) {
                            $storeOpenText.text(storeHoursText);
                            $updateStore.attr('data-store-hours-text', storeHoursText);
                            if (isSPC) {
                                $storeOpenText.html(storeHoursText);
                            }

                            if (!isSPC) {
                                const storeStatus = $('.store-hours-status');
                                const storeUntil = $('.store-hours-until');
                                if (storeStatus && storeUntil) {
                                    if (isStoreOpen) {
                                        storeStatus.text('Open');
                                        storeStatus.addClass('store-open');
                                        storeUntil.text(storeHoursText.replace('Open', '').replace(':00 ', ''));
                                    } else {
                                        storeStatus.text('Closed');
                                        storeUntil.text(storeHoursText.replace('Closed', '').replace(':00 ', ''));
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    },

    buildStoreHours: function (isSPC) {
        var $stores = $('[data-store-id]');

        $stores.each(function (index, store) {
            var $store = $(store);
            var storeID = $store.attr('data-store-id');
            var $updateStore = $('[data-store-id="' + storeID + '"]');
            var hours = $store.attr('data-store-hours');
            var parsedHours = null;

            try {
                parsedHours = JSON.parse(hours);
            } catch (ex) {
                parsedHours = null;
            }

            if (parsedHours) {
                var hoursHtml = !isSPC ? '<div class="col-md-6 store-hours mt-3 mt-md-0">' : '';
                hoursHtml += !isSPC ? '<h4>Hours</h4>' : '';
                hoursHtml += '<div class="store-hours-table">';

                for (var i = 0; i < parsedHours.length; i++) {
                    var day = parsedHours[i].day;
                    var open = parsedHours[i].open;
                    var close = parsedHours[i].close;

                    var openHours = open.substring(0, 2);
                    var openMins = open.substring(2, 4);
                    var openTime = openHours + ':' + openMins;

                    var closeHours = close.substring(0, 2);
                    var closeMins = close.substring(2, 4);
                    var closeTime = closeHours + ':' + closeMins;

                    hoursHtml += '<div class="store-hour-set">';
                    hoursHtml += '<span class="day">' + day + ':</span>';
                    if (open === 'CLOSED' || close === 'CLOSED') {
                        hoursHtml += '<span class="time"><span>Closed</span>';
                    } else {
                        hoursHtml += '<span class="time"><span>' + formatTime(openTime) + '</span> <span class="to-time">-</span><span> ' + formatTime(closeTime) + '</span>';
                    }
                    hoursHtml += '</div>';
                }

                hoursHtml += '</div></div>';
                if (!isSPC) {
                    $updateStore.find('.store-main-info').after(hoursHtml);
                } else {
                    $updateStore.find('#storeHours .store-hours').empty().append(hoursHtml);
                }
            }
        });
    },

    buildOrderConfirmationStoreHours: function () {
        var $stores = $('[data-store-id]');
        var $orderConfirm = $('.page[data-action="Order-Confirm"]').length;

        if (!$orderConfirm) {
            return;
        }
        $stores.each(function (index, store) {
            var $store = $(store);
            var storeID = $store.attr('data-store-id');
            var $updateStore = $('[data-store-id="' + storeID + '"]');
            var hours = $store.attr('data-store-hours');
            var parsedHours = null;

            try {
                parsedHours = JSON.parse(hours);
            } catch (ex) {
                parsedHours = null;
            }

            if (parsedHours) {
                var hoursHtml = '<div class="store-hours mt-3">';
                hoursHtml += '<p class="head">Store hours</p>';
                hoursHtml += '<div class="store-hours-table">';

                for (var i = 0; i < parsedHours.length; i++) {
                    var day = parsedHours[i].day;
                    var open = parsedHours[i].open;
                    var close = parsedHours[i].close;

                    var openHours = open.substring(0, 2);
                    var openMins = open.substring(2, 4);
                    var openTime = openHours + ':' + openMins;

                    var closeHours = close.substring(0, 2);
                    var closeMins = close.substring(2, 4);
                    var closeTime = closeHours + ':' + closeMins;

                    hoursHtml += '<div class="store-hour-set mt-1">';
                    hoursHtml += '<span class="day">' + day + ':</span>';
                    if (open === 'CLOSED' || close === 'CLOSED') {
                        hoursHtml += '<span class="time"><span>Closed</span>';
                    } else {
                        hoursHtml += '<span class="time"><span>' + formatTime(openTime) + '</span> <span class="to-time">-</span><span> ' + formatTime(closeTime) + '</span>';
                    }
                    hoursHtml += '</div>';
                }

                hoursHtml += '</div></div>';
                $updateStore.find('.store-main-info').after(hoursHtml);
            }
        });
    },

    storeInventorySearch: function () {
        $('.btn-store-inventory-search').on('click submit', function () {
            var $this = $(this);
            var submitURL = $this.data('submitUrl');

            var queryParams = {
                json: true,
                productId: $('#productid-search-input').val(),
                radius: $('#radius').val(),
                postalCode: $('#zipcode-search-input').val(),
            };
            var queryString = encodeQueryParams(queryParams);
            var url = `${submitURL}?${queryString}`;

            fetch(url)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data.results) {
                        if (data.results.locations) {
                            var $mapDiv = $('.map-canvas');
                            $mapDiv.attr('data-locations', data.results.locations);
                            maps(null, true);
                        }
                    }
                })
                .catch(error => {
                    console.error("There was an error with the fetch operation:", error);
                });
        });
    },
    clearSearch: function () {
        $('.profile-store-search .search-clear').on('click', function () {
            const searchInput = $('.profile-store-search .form-control');
            searchInput.val('');
        });
    }


});

module.exports = exportBase;
